import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {ApiService} from "../../../services/api.service";
import {TemplateService} from "../../../services/template.service";
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import { GroupedSaleTaxListDetailComponent } from '../grouped-list-detail/grouped-list-detail.component'


@Component({
  selector: 'app-saletax-grouped-list',
  templateUrl: './grouped-list.component.html',
  styleUrls: ['./grouped-list.component.scss']
})
export class GroupedSaleTaxListComponent implements OnInit {
  inputText: any;
  list: any = [];
  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  totalItems: number;
  currentPage = 1;
  checked = false;
  url: any;
  date: Date;
  loading = false;

  @ViewChild('detailModal') detailModal: GroupedSaleTaxListDetailComponent;

  constructor(private apiService: ApiService,
              private template: TemplateService) {
  }

  ngOnInit() {
    this.pageChanged();
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.searchE(params);
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  clearSearch() {
    this.startDate = null;
    this.endDate = null;
    this.inputText = null;

    if (this.currentPage === 1)
      this.searchE()
    else
      this.currentPage = 1
  }

  searchE(params?) {
    const searchParams = {
      group_data_by_month: true,
      document_type: ['tax_invoice', 'receipt'],
      search_box: this.inputText,
      start_date: this.startDate==null ? this.startDate : moment(this.startDate).format('YYYY-MM-DD'),
      end_date: this.endDate==null ? this.endDate : moment(this.endDate).format('YYYY-MM-DD'),
    };
    this.loading = true;
    this.setModalSearchParams(searchParams)
    if (this.currentPage === 1) {
      this.apiService.postSearch(searchParams).subscribe(
        (res: any) => {
          this.list = res.results;
          this.totalItems = res.count;
          this.loading = false;
        }
      );
    } else {
      this.apiService.postSearch1(searchParams, params).subscribe(
        (res: any) => {
          this.list = res.results;
          this.totalItems = res.count;
          this.loading = false;
        }
      );
    }
  }

  setModalSearchParams(searchParams) {
    searchParams = _.cloneDeep(searchParams)
    searchParams['group_data_by_month'] = false
    this.detailModal.searchParams = searchParams
  }

  openModal(data, index) {
    this.detailModal.open(data)
  }

  download(data, index) {
    data.pdfLoading = true;
    this.apiService.getSalesTaxReport({'month':data.month, 'year':data.year}).subscribe(
      (obj) => {
        let filename = 'documents' + moment().format('YYYY-MM-DD') + '.pdf';
        this.apiService.createDownloadFile(obj, filename);
        data.pdfLoading = false;
      },
      error => {
        data.pdfLoading = false;
      }
    )
  }

  downloadZip2MB(data, index) {
    data.xmlLoading = true;
    this.apiService.getZip2MB({'month':data.month, 'year':data.year}).subscribe(
      (obj) => {
        let filename = 'documents' + moment().format('YYYY-MM-DD') + '.zip';
        this.apiService.createDownloadFile(obj, filename);
        data.xmlLoading = false;
      },
      error => {
        data.xmlLoading = false;
      }
    )
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/grouped-list/grouped-list.component.ts